<template>
     <div>
        <!-- CHAT CLIENT UI -->
        <div class="container-fluid"
             v-show="activeScreen === ScreensEnum.conversationClient">
            <div class="row">
                <div>
                    <div class="panel">
                        <div class="clearfix panel-heading branding-background branding-text chat-heading">
                            <h3 class="panel-title pull-left"><i class="glyphicon glyphicon-comment"></i>&nbsp;<span v-html="agentName"></span></h3>
                            <div class="pull-right">
                                <a @click.prevent="nextScreen(ScreensEnum.chatButton)" href="" class="branding-text min-chat" title="Minimize Chat"><i class="glyphicon glyphicon-menu-down"></i></a>
                                <a @click.prevent="toggleEndChatScreen(true)" href="" class="branding-text close-chat" v-bind:title="[activeChat ? 'End Chat' : 'Close Chat']"><i class="glyphicon glyphicon-remove"></i></a>
                            </div>
                        </div><!--chat-heading-->
                        <div id="chat-window" class="panel-body chat-window">
                            <ul class="list-unstyled text-right">

                                <div class="clearfix" v-for="item in messages" :key="item.message">
                                    <li class="panel" v-bind:class="[item.direction === MessageDirection.Outgoing ? 'outgoing-response' : 'incoming-response']">
                                        <ul class="list-unstyled panel-body">
                                            <li v-html="item.message"></li>
                                            <li class="text-muted timestamp-response"><small v-html="item.name"></small></li>
                                        </ul>
                                    </li>
                                </div>

                            </ul>
                            <p v-show="awaitingAgent" class="text-muted text-left awaiting-response"><small>Awaiting agent...</small></p>
                            <p v-show="!activeChat" class="text-muted text-center end-response">Your conversation has ended.<br><a @click.prevent="nextScreen(ScreensEnum.transcript)" href="">Click here for a transcript.</a></p>
                        </div><!--chat-window-->
                        <div class="panel-body chat-reply">
                            <div class="input-group input-group-lg">
                                <textarea @keyup.enter="sendMessage" v-model="message" id="btn-input" type="text" class="form-control" placeholder="Type your message here..." maxlength="250"></textarea>
                                <span class="input-group-btn">
                                    <button @click="sendMessage" :disabled="disableSendMessageButton" class="btn branding-background branding-text send-response" id=""><i class="glyphicon glyphicon-send"></i></button>
                                </span>
                            </div>
                        </div><!--chat-reply-->
                    </div><!--panel-->
                </div><!--col-->
            </div><!--row-->
        </div><!--container-->
        <!-- END CHAT -->
        <div class="container-fluid"
             v-show="showEndChatScreen">
            <div class="row">
                <div class="text-center chat-end">
                    <h3>End this chat?</h3>
                    <button @click="endChat" class="btn btn-danger btn-lg" id="">End Chat</button>
                    <button @click="toggleEndChatScreen(false)" class="btn btn-default btn-lg" id="">Return</button>
                </div><!--col-->
            </div><!--row-->
        </div><!--container-->
    </div>
</template>

<script>
import screenNavMixin from "../mixins/screen-nav";
import linkifyHtml from "linkify-html";

export default {
        mixins: [screenNavMixin],
        data: function () {
            return {
                message: '',
                showEndChatScreen: false
            }
        },
        computed: {
            activeChat: function () {
                return this.sharedStore.state.activeChat;
            },
            disableSendMessageButton: function () {
                return !this.sharedStore.state.activeChat;
            },
            messages: function () {
                return this.sharedStore.state.messages;
            },
            agentName: function () {
                return this.sharedStore.state.agent.name;
            },
            awaitingAgent: function () {

                // If chat has not ended and the last message sent was from the user,
                // then we are waiting for the agent to respond.
                const lastMessage = this.messages[this.messages.length - 1];

                if (lastMessage) {
                    return lastMessage.direction === this.MessageDirection.Outgoing && this.activeChat;
                }

                return true;
            }
        },
        methods: {
            clearMessage: function () {
                this.message = '';
            },
            toggleEndChatScreen: function (show) {
                this.showEndChatScreen = show;
            },
            endChat: function () {

                // Service call to record end chat and destroy channel
                this.$chatService.endChat();

                // Close Chat Screen
                this.toggleEndChatScreen(false);

                // End Active Chat
                this.sharedStore.mutations.setActiveChat(false);

                // Launch next screen
                this.nextScreen(this.ScreensEnum.transcript);

            },
            scrollChatWindow: function () {
                const chatElem = document.getElementById('chat-window');
                if (chatElem) {
                    chatElem.scrollTop = chatElem.scrollHeight;
                }
            },
            sendMessage: function () {

                const context = this;    
                if (context.validMessage()) {

                    const linkifiedMessage = linkifyHtml(context.message, {
                        defaultProtocol: 'http',
                        tagName: 'a',
                        target: {
                            url: '_blank'
                        }
                    });

                    // Add message to shared state
                    context.sharedStore.mutations.addMessage(
                        {
                            direction: context.MessageDirection.Outgoing,
                            name: 'You',
                            message: linkifiedMessage
                        }
                    );

                    // Send Message Sms
                    context.$chatService.sendMessage(context.message);

                    context.clearMessage();
                    context.scrollChatWindow();
                }

            },
            validMessage: function () {
                return this.message.length > 0;
            }
        },
        updated: function () {
            this.scrollChatWindow();
        },
        created: function () {
            // Register onbeforeunload window event handler to clean up any active chats
            // if user navs away
            window.onbeforeunload = function () {
                this.$chatService.updateConversation({Active: false});
            }
        }
    
};
</script>

<style>
</style>